import { PasswordValidationConfig, PasswordValidationRule } from '../../components/ChangePasswordInputs'

export const passwordConfig: PasswordValidationConfig = {
  [PasswordValidationRule.MIN_LENGTH]: 8,
  [PasswordValidationRule.REQUIRE_UPPERCASE]: true,
  [PasswordValidationRule.REQUIRE_LOWERCASE]: true,
  [PasswordValidationRule.REQUIRE_NUMBERS]: true,
  [PasswordValidationRule.REQUIRE_SPECIAL_CHARS]: true
}
